<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Modeless dialog, default color" />
    <vc-dialog width="640px" :show="open1" @close="open1 = false">
      <vc-dialog-header :close-button="true" icon="home">Modeless Dialog with Default Color</vc-dialog-header>
      <vc-dialog-content>
        <vc-lorem-ipsum :repeats="3" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="primary" @click="open1 = false">Cancel</vc-button>
        <vc-button color="primary" @click="doSomething('open1')">Do Something</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-button icon-left="home" :disabled="open1 === true" color="primary" @click="open1 = true">Open: {{ open1 }}</vc-button>
    <example-title src="example-2.html" title="Modal dialog, light theme and custom color" />
    <vc-dialog color="green l-300" :dark="false" :show="open2" modal @close="open2 = false" width="700px">
      <vc-dialog-header :close-button="true" icon="schedule">Modal dialog, light theme and custom color</vc-dialog-header>
      <vc-dialog-content>
        <vc-lorem-ipsum :repeats="1" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="green l-300" :dark="false" @click="open2 = false">Cancel</vc-button>
        <vc-button color="green l-300" :dark="false" @click="doSomething('open2')">Do Something</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-button icon-left="schedule" :disabled="open2 === true" color="green l-300" :dark="false" @click="open2 = true">Open: {{ open2 }}</vc-button>
    <example-title src="example-3.html" title="Modal dialog with content max-height" />
    <vc-dialog color="deep-purple" :show="open3" modal @close="open3 = false" width="500px">
      <vc-dialog-header :close-button="true" icon="mdi-github-circle">Modal dialog with content max-height</vc-dialog-header>
      <vc-dialog-content max-height="220px">
        <vc-lorem-ipsum :repeats="5" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="deep-purple" @click="open3 = false">Cancel</vc-button>
        <vc-button color="deep-purple" @click="doSomething('open3')">Do Something</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-button icon-left="mdi-github-circle" :disabled="open3 === true" color="deep-purple" @click="open3 = true">Open: {{ open3 }}</vc-button>
    <example-title src="example-4.html" title="Modal dialog that cannot be closed on overlay click" />
    <vc-dialog color="pink" :close-on-outside-click="false" :show="open4" modal @close="open4 = false" width="500px">
      <vc-dialog-header :close-button="true" icon="mdi-lastfm">Modal dialog that cannot be closed on overlay click</vc-dialog-header>
      <vc-dialog-content>
        <vc-lorem-ipsum :repeats="2" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="pink" @click="open4 = false">Cancel</vc-button>
        <vc-button color="pink" @click="doSomething('open4')">Do Something</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-button icon-left="mdi-lastfm" :disabled="open4 === true" color="pink" @click="open4 = true">Open: {{ open4 }}</vc-button>
    <example-title src="example-5.html" title="Full screen" />
    <vc-dialog color="orange" :fullscreen="true" :show="open5" modal @close="open5 = false">
      <vc-dialog-header :close-button="true" icon="camera">Fullscreen Dialog</vc-dialog-header>
      <vc-dialog-content>
        <vc-lorem-ipsum :repeats="2" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="orange" @click="open5 = false">Cancel</vc-button>
        <vc-button color="orange" @click="doSomething('open5')">Do Something</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <vc-button icon-left="camera" :disabled="open5 === true" color="orange" @click="open5 = true">Open: {{ open5 }}</vc-button>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'DialogPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      open1: false,
      open2: false,
      open3: false,
      open4: false,
      open5: false
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    doSomething (model) {
      alert('You clicked the "do something and close button"')
      this[model] = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/dialog.vue